import { ModalProp } from "@/types";

export const IntegrationAddressInfoProps: ModalProp[] = [
  {
    key: "contact",
    label: "Contact",
  },
  {
    key: "email",
    label: "Email",
  },
  {
    key: "phone",
    label: "Phone",
  },
  {
    key: "street",
    label: "Street",
  },
  {
    key: "detail",
    label: "Detail",
  },
  {
    key: "block",
    label: "Block",
  },
  {
    key: "city",
    label: "City",
  },
  {
    key: "state",
    label: "State",
  },
  {
    key: "zip",
    label: "Zip",
  },
  {
    key: "country",
    label: "Country",
  },
  {
    key: "company",
    label: "Company",
  },
];
